var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayondemand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.514,
    height: 80,
    viewBox: "0 0 73.514 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pay_on_demand",
    "data-name": "pay on demand",
    transform: "translate(-24 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dollar-Sign",
    d: "M54.289,89.988H47V83.063H60.631v-3.5H47V62.289h7.289V55h7.289v7.289H67.41v6.925H53.779v3.5H67.41V89.988H61.578v5.831H54.289Z",
    transform: "translate(-6.495 -10.067)",
    fill: "#f48a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Square",
    transform: "translate(24 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    d: "M30.919,87.027H24V32.252H54.991V39.1H30.919ZM78.775,100H31.207V93.225H72V52.432h6.775ZM68.18,39.459l-9.586-9.586,4.829-4.829,9.586,9.586Zm6.7,7.928-4.757-4.757L92.685,20l4.829,4.757Z",
    transform: "translate(-24 -20)",
    fill: "#12355f",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayondemand);
export default __webpack_public_path__ + "static/media/pay on demand.5713bf87b0295f1ff0ff7ecfe4fc554a.svg";
export { ForwardRef as ReactComponent };